export default __webpack_public_path__ + "static/media/ic_syria.38f00dcd.svg";